<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button type="button" (click)="backToPage()" title="Back">
        <ion-icon name="chevron-back-outline"></ion-icon>&nbsp;Back
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ion-icon name="book"></ion-icon>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button type="button" (click)="nextPage()" title="Next">
        Next&nbsp;<ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" #content>
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop"><ion-label class="banner-title">Organisation Information</ion-label></ion-col>
    </ion-row>
  </ion-grid>
  <form [formGroup]="organisationForm"  class="form margin-top-1rem" *ngIf="accessibleMode!=='VIEW'" ngNativeValidate>
    <ion-list id="orgInfoForm">
      <ion-item>
        <ion-label>Type {{organisationForm.get('type')?.value}}</ion-label>
      </ion-item>
      <ion-item>
        <ion-select placeholder="Select a Sub Type" formControlName="subType">
          <div slot="label">Sub Type <ion-text color="danger">*</ion-text></div>
          <ion-select-option *ngFor="let itemSubType of subTypeList" [value]="itemSubType">{{ itemSubType }}</ion-select-option>
        </ion-select>       
      </ion-item>
      <ion-item *ngIf="organisationForm.get('subType')?.invalid && organisationForm.get('subType')?.touched">
        <ion-text color="danger">Sub Type is required</ion-text>
      </ion-item>
      <ion-item>
        <ion-select  placeholder="Select a State" formControlName="state" [attr.disabled]="accessibleMode==='VIEW'" required>
          <div slot="label">State <ion-text color="danger">*</ion-text></div> 
          <ion-select-option *ngFor="let state of stateList" [value]="state.stateCode">{{state.stateName}}</ion-select-option>
          </ion-select>              
      </ion-item>
      <ion-item *ngIf="organisationForm.get('state')?.invalid && organisationForm.get('state')?.touched">
        <ion-text color="danger">State is required</ion-text>
      </ion-item>
      <ion-item>
        <!-- <ion-input id="entityTypeName" name="entityTypeName" type="text" placeholder="Please Enter Association Name" formControlName="entityTypeName">
          <div slot="label">Association Name<ion-text color="danger">*</ion-text></div>
        </ion-input> -->
        <div class="autocomplete-container">
          <label class="autocomplete-label" for="entityTypeName">Association Name<ion-text color="danger">*</ion-text></label>
          <input placeholder="Select or Type Association" type="text" [matAutocomplete]="assocAuto" id="entityTypeName"
           class="autocomplete-input" name="entityTypeName" formControlName="entityTypeName">
          <mat-autocomplete #assocAuto="matAutocomplete">
            @for (option of filteredOptionsAssoc | async; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-autocomplete>
        </div>
      </ion-item>
      <ion-item *ngIf="organisationForm.get('entityTypeName')?.invalid && organisationForm.get('entityTypeName')?.touched">
        <ion-text *ngIf="organisationForm.get('entityTypeName')?.hasError('required')" color="danger">Association Name is required</ion-text>
        <ion-text *ngIf="organisationForm.get('entityTypeName')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>        
        <!-- <ion-text *ngIf="organisationForm.get('entityTypeName')?.hasError('maxlength')" color="danger">>Only maxium(50) Character</ion-text>         -->
      </ion-item>
      <ion-item>
        <!-- <ion-input id="subEntityName" name="subEntityName" type="text" placeholder="Please Enter Club Name"
        formControlName="subEntityName" maxlength="50">
          <div slot="label">Club Name<ion-text color="danger">*</ion-text></div>
        </ion-input> -->
        <div class="autocomplete-container">
          <label class="autocomplete-label" for="subEntityName">Club Name<ion-text color="danger">*</ion-text></label>
          <input placeholder="Select or Type Club Name" [matAutocomplete]="clubAuto" id="subEntityName"
           class="autocomplete-input" name="subEntityName" formControlName="subEntityName">
          <mat-autocomplete #clubAuto="matAutocomplete">
            @for (option of filteredOptionsClub | async; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-autocomplete>
        </div>
      </ion-item>
      <ion-item *ngIf="organisationForm.get('subEntityName')?.invalid && organisationForm.get('subEntityName')?.touched">
        <ion-text *ngIf="organisationForm.get('subEntityName')?.hasError('required')" color="danger">Club Name is required</ion-text>
        <ion-text *ngIf="organisationForm.get('subEntityName')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
      </ion-item>      
      <ion-item>
      <ion-input id="inspectionDateTime" name="inspectionDateTime" type="datetime-local" formControlName="inspectionDateTime">
        <div slot="label">Inspection Date<ion-text color="danger">*</ion-text></div>
      </ion-input>            
      </ion-item>
      <ion-item *ngIf="organisationForm.get('inspectionDateTime')?.invalid && organisationForm.get('inspectionDateTime')?.touched">
        <ion-text color="danger">Inspection Date Time is required</ion-text>
      </ion-item>
      <ion-item  class="transparent-background"></ion-item>
    </ion-list>
  </form>
 
  <ion-grid *ngIf="accessibleMode==='VIEW'">
    <ion-row >
      <ion-col>
        <ion-card class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{organisationForm.get('type')?.value}}</ion-card-title>
                </ion-col>
              </ion-row>             
            </ion-grid>
          </ion-card-header>
      
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Sub Type</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('subType')?.value">{{ organisationForm.get('subType')?.value }}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('subType')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">State</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('state')?.value">{{ organisationForm.get('state')?.value }}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('state')?.value">&lt;empty&gt;</ion-label>             
              </ion-item>

              <ion-item>
                <ion-label class="item-title">Association Name</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('entityTypeName')?.value">{{ organisationForm.get('entityTypeName')?.value }}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('entityTypeName')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Club Name</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('subEntityName')?.value">{{organisationForm.get('subEntityName')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('subEntityName')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
              <ion-item>
                <ion-label class="item-title">Inspection Date Time</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('inspectionDateTime')?.value">{{organisationForm.get('inspectionDateTime')?.value | date:'dd-MM-yyyy HH:mm'}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('inspectionDateTime')?.value">&lt;empty&gt;</ion-label>
              </ion-item>

              <!-- <ion-item>
                <ion-label class="item-title">Club Name</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('subEntityName')?.value">{{organisationForm.get('subEntityName')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('subEntityName')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
              <ion-item>
                <ion-label class="item-title">Club Name</ion-label>
                <ion-label class="item-content" *ngIf="organisationForm.get('subEntityName')?.value">{{organisationForm.get('subEntityName')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!organisationForm.get('subEntityName')?.value">&lt;empty&gt;</ion-label>
              </ion-item> -->

            </ion-list>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>